import script from "./PackageTemplateStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageTemplateStep.vue?vue&type=script&setup=true&lang=ts"

import "./PackageTemplateStep.vue?vue&type=style&index=0&id=49e8c8dd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e8c8dd"]])

export default __exports__